import { createI18n, I18n } from 'vue-i18n';

import deutschMessages from './locale/de.json';
import englishMessages from './locale/en.json';
import spanishMessages from './locale/es.json';
import frenchMessages from './locale/fr.json';
import italianMessages from './locale/it.json';
import japaneseMessages from './locale/ja.json';
import koreanMessages from './locale/ko.json';
import portugueseMessages from './locale/pt_BR.json';
import rusianMessages from './locale/ru.json';
import simplifiedChineseMessages from './locale/zh_CN.json';
import chineseMessages from './locale/zh_TW.json';

export const AVAILABLE_LANGUAGES = [
	'en',
	'es',
	'de',
	'fr',
	'ko',
	'pt',
	'pt-br',
	'ja',
	'it',
	'ru',
	'zh-tw',
	'zh-cn',
];

export const i18n = (): I18n => {
	const url = new URL(window.location.href);
	const lang = url.searchParams.get('language') ?? 'en';

	return createI18n({
		legacy: false,
		locale: AVAILABLE_LANGUAGES.includes(lang) ? lang : 'en',
		fallbackLocale: 'en',
		messages: {
			en: englishMessages,
			es: spanishMessages,
			de: deutschMessages,
			fr: frenchMessages,
			ko: koreanMessages,
			pt: portugueseMessages,
			'pt-br': portugueseMessages,
			ja: japaneseMessages,
			it: italianMessages,
			ru: rusianMessages,
			'zh-tw': chineseMessages,
			'zh-cn': simplifiedChineseMessages,
		},
	});
};
